/**
 * Danish translations of the public "What's new" entries in `./changelog.ts`.
 *
 * Unlike `changelog.ts`, this file is hand-maintained: the
 * `publish-public-changelog` skill only rewrites the `generated:entries` region
 * of the English file and never touches this one.
 *
 * Entries are matched to the English ones by `date`. A date with no entry here
 * falls back to its English text on the page, so a freshly published entry is
 * never hidden — it just shows in English until it is translated and added
 * below. Each translated entry must have the same categories, in the same
 * order, with the same number of items as its English counterpart (enforced by
 * `src/pages/Changelog.test.tsx`).
 */

import { ChangelogEntry } from "./changelog";

export const CHANGELOG_ENTRIES_DA: ChangelogEntry[] = [
  {
    date: "2026-10-23",
    sections: [
      {
        category: "Fixed",
        items: [
          "Markeret tekst i dine sendte spørgsmål har nu en synlig fremhævning, så du kan se præcis, hvad du kopierer.",
          "Svar, der starter med fed tekst, flugter nu med Tally-logoet, også mens Tally stadig skriver.",
        ],
      },
    ],
  },
  {
    date: "2026-10-17",
    sections: [
      {
        category: "Changed",
        items: [
          "Stemmesamtaler flyder mere naturligt med færre stille pauser, tydeligere beskeder om fremdriften og bedre håndtering, når du afbryder.",
        ],
      },
    ],
  },
  {
    date: "2026-10-11",
    sections: [
      {
        category: "Added",
        items: [
          "Spørg Tally om dit salg i Business Central—fra omsætning og avancer til dine største kunder, salgstendenser og sammenligninger med dit budget.",
        ],
      },
    ],
  },
  {
    date: "2026-10-09",
    sections: [
      {
        category: "Added",
        items: [
          "I sidepanelet med samtaler markerer en pulserende prik nu hver samtale, Tally stadig svarer på, og en fyldt prik markerer en, hvor svaret er klar.",
          "Når sidepanelet er lukket, har knappen, der åbner det, den samme prik, så du kan se, at et svar er kommet, uden at åbne sidepanelet.",
        ],
      },
      {
        category: "Changed",
        items: [
          "Sidepanelet med samtaler er nu åbent, når du starter Tally på en computer, og bliver, som du forlod det, i stedet for at klappe sammen ved hvert besøg.",
          "På en tabletstor skærm lukker sidepanelet ikke længere sig selv, i det øjeblik du vælger en samtale.",
          "Arbejd videre på tværs af samtaler, mens Tally svarer—op til fem spørgsmål kan køre samtidig.",
          "Microsoft Business Central er nu tilgængelig for alle Tally-konti — forbind det fra siden Integrationer for at stille Tally spørgsmål om dine kunder, leverandører, fakturaer og økonomi.",
        ],
      },
    ],
  },
  {
    date: "2026-09-30",
    sections: [
      {
        category: "Changed",
        items: [
          "Tally har fået nyt udseende: mere rolige, varmere farver med blødere kort og knapper, og brun markerer nu det valgte i stedet for at fylde hele paneler. Dine samtaler, dashboards og indstillinger er uændrede.",
          "Menuknappen og sidetitlen sidder nu sammen i en slank bjælke øverst på siden.",
          "Hvis du arbejder med flere virksomheder, viser virksomhedsskifteren nu hver virksomheds initialer og fremhæver den, du er i.",
        ],
      },
      {
        category: "Fixed",
        items: [
          "Dashboards, tale og Business Central, hvor det er aktiveret for din virksomhed, forbliver ikke længere skjulte resten af sessionen efter et kort indlæsningshik — Tally prøver nu selv igen.",
        ],
      },
    ],
  },
];
